import * as React from 'react';
import { useCartStore } from 'src/hooks/cart';

const BomToCartItemReplacePopup = (props) => {
    const { SetStatus, data } = props;
    let cartReplaceItem = data.cartReplaceItem
    const [{ }, { }, { replace_cart_in_Bulk }] = useCartStore();

    const replaceCartItem = async () => {
        let res = await replace_cart_in_Bulk(cartReplaceItem, true);
    }

    return (
        <>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">Customer Part Number</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <p>There are duplicate items in your cart with a different Customer Part Number. Do you want to replace them?</p>
                    </div>

                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto"
                                data-bs-toggle="modal"
                                onClick={() => {
                                    SetStatus(false)
                                }}>
                                Cancel
                            </button>
                            <button type="submit" className="bs5 btn btn-primary minw-auto"
                                data-bs-toggle="modal"
                                onClick={() => {
                                    replaceCartItem()
                                }}>
                                Replace
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BomToCartItemReplacePopup;